import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { JournalList } from './pages/JournalList';
import { JournalDashboard } from './pages/JournalDashboard';
import { DocsPage } from './pages/DocsPage';
import { VizPage } from './pages/VizPage';
import { RoadmapPage } from './pages/RoadmapPage';
import { SpinePage } from './pages/SpinePage';
import { AdlcPage } from './pages/AdlcPage';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<JournalList />} />
        <Route path="/docs" element={<DocsPage />} />
        <Route path="/viz" element={<VizPage />} />
        {/* /roadmap is the STORY; /roadmap/detail is the instrument. The swap is the whole
            point of the redesign — the five-reading view is still complete and still one
            click away, it just stopped being the first thing a reader meets. Keeping the
            URL means every existing link to /roadmap lands on the new page rather than on
            a redirect nobody maintains. */}
        <Route path="/roadmap" element={<SpinePage />} />
        <Route path="/roadmap/detail" element={<RoadmapPage />} />
        <Route path="/adlc" element={<AdlcPage />} />
        {/* Keep `/:rootId` last. It is a catch-all: a static route declared after it is
            still matched first by react-router's ranking, but the ordering here is what
            makes that obvious to the next reader rather than a property they have to
            know. Anything added below this line will be shadowed at a glance. */}
        <Route path="/:rootId" element={<JournalDashboard />} />
      </Routes>
    </BrowserRouter>
  );
}
